<template>
  <div class="content-message">
    <div class="hint-title">提示</div>
    <div class="hint-text">系统会在每天2：00将前一天结算佣金转至可提现账户中。您可前往账户中心进行提现。<span @click="goWithdraw">前往提现</span></div>
    <div class="title">资金明细</div>
    <div class="search">
      <el-form class="search-from" ref="form" :model="searchForm" label-width="85px">
        <el-form-item label="流水号">
          <el-input style="width: 160px;" v-model="searchForm.orderUuid" placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <el-form-item label="资金明细">
          <el-input style="width: 160px;" v-model="searchForm.source" placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="searchForm.type" placeholder="请选择" size="small"  :clearable="true">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="search-button">
          <div class="button-refer" @click="search">查询</div>
          <div class="button-export" @click="exportButton">导出</div>
        </div>
      </el-form>
    </div>
    <div class="table">
      <div class="table-list">
        <el-table
          :data="list.list"
          style="width: 100%"
          :header-cell-style="bgColor"
        v-loading="loading">
<!--          <el-table-column-->
<!--            label="序号"-->
<!--            width="80"-->
<!--            align="center">-->
<!--            <template slot-scope="{row}">-->
<!--              <span>{{ row.id }}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
            label="流水号"
            width="180"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.relationId }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="类型"
            align="center"
            width="180">
            <template slot-scope="{row}">
              <span class="span" v-if="row.type>0">收入</span>
              <span class="span2" v-if="row.type<0">支出</span>
            </template>
          </el-table-column>
          <el-table-column
            label="资金明细"
            align="center"
            width="180">
            <template slot-scope="{row}">
              <span>{{ row.remark }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="变动金额"
            align="center"
            width="180">
            <template slot-scope="{row}">
              <span>{{ row.amountBig }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="变动时间"
            align="center"
            width="180">
            <template slot-scope="{row}">
              <span>{{ row.createTime }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="变动后的账户金额"
            align="center"
            width="180">
            <template slot-scope="{row}">
              <span>{{ row.afterAmountBig }}元</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="list.total > 0"
          background
          class="align-right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="list.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="list.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {saasOrder} from "../../../../javaApi/saasOrder";
const  SaasM = new saasOrder()
export default {
name: "index",
  data(){
  return{
    searchForm:{
      orderUuid:'',
      type:'',
      source:'',
      pageNo:1,
      pagSize:10
    },
    list:[],
    currentPage:1,
    // 表头颜色
    bgColor:{
      background: '#FCFAF8'
    },
    options:[{
      label:'收入',
      value:'1'
    },
      {
        label:'支出',
        value:'-1'
      }],
    loading:true
  }
  },
  mounted() {
  this.getList()
  },
  methods:{
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchForm.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchForm.pageNo = val
      this.getList()
    },
    getList(){
      SaasM.financialDetails(this.searchForm).then(res=>{
        if(res.data.code == 200){
          this.list = res.data.data
          this.loading = false
        }else{
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    search(){
      this.loading = true
      this.getList()
    },
    // 去提现
    goWithdraw(){
      this.$router.push('/pc/user/accountWithdrawal')
    },
    // 导出
    exportButton(){
      SaasM.exportDetail(this.searchForm).then(res=>{
        console.log(res)
        if(res.status == 200){
          const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
          console.log('blob',blob)
          let url = window.URL.createObjectURL(blob);
          console.log('url',url)
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = window.URL.createObjectURL(blob);;
          a.download = "订单导出_" + this.formatDate(new Date()) + ".xls";
          a.click();
          window.URL.revokeObjectURL(url);
        }else{
          // this.$Message.error(res.info || res.message)
        }
      })
    },
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      return y + m + d;
    },
  }
}
</script>

<style scoped lang="less">
.content-message{
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  min-height: 92%;
  .title{
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    line-height: 25px;
  }
  .search{
    margin-top: 20px;
    display: flex;
    align-items: center;
    .search-from{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    .search-button{
      display: flex;
      align-items: center;
      margin-left: 20px;
      .button-refer{
        width: 76px;
        height: 32px;
        background: #FF8622;
        border-radius: 2px;
        text-align: center;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 32px;
        cursor: pointer;
      }
      .button-export{
        width: 76px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #FF8622;
        text-align: center;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FF8622;
        line-height: 32px;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
}
.hint-title{
  font-weight: 700;
  color: #000000;
  margin-top: 20px;
}
.hint-text{
  margin-top: 10px;
  margin-left: 20px;
  margin-bottom: 20px;
  span{
    color: red;
    cursor: pointer;
  }
}
/deep/.el-form-item{
  margin-bottom: 0;
}
.table{
  margin-top: 20px;
}
/deep/.el-form-item{
  margin-bottom: 0;
}
.table{
  margin-top: 20px;
}
/deep/.el-form-item{
  margin-bottom: 0;
}
/deep/.el-dialog__header{
  border-bottom: 1px solid #e5e5e5;
}
/deep/.el-input__inner:focus{
  border-color: #FF8622!important;
}
/deep/.el-range-editor.is-active, .el-range-editor.is-active:hover{
  border-color: #FF8622!important;
}
/deep/.el-date-table td.today{
  background: #FF8622;
}
/deep/.el-input__inner:hover{
  background: #FCF8F5;
  border-color: #FF8622!important;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #FF8622!important;
}
.align-right{
  text-align: right;
  margin-top: 20px;
}
.span{
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #3D9EFC;
  line-height: 20px;
}
.span2{
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF4F76;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/SaasJoin/financialDetails/index.vue